import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import DefaultImage from "../Assest/img/simulanis.png";
import { AddProjectLightIcon, NoDataImage } from "../Assest/icons/icons";
import ProjectSkeleton from "../components/skeletons/project";
import AddProject from "../components/modals/AddProject";
import apiClient from "../apiClient/index";
import { CREATE_MODULE, FETCH_MODULE_LIST } from "../apiClient/apiEndpoints";
import { useNavigate } from "react-router-dom";
import { debounceFunc } from "../utils/helpers";

const { SearchBar, NormalGradientButton } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ModuleList = ({ isMobileView = false }) => {
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [addProject, setAddProject] = useState(false);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();
  const configData = useUnoSelector((state) => state.config);
  const UNO_URL = configData.config.UNO_URL;
  const LIMIT = 25;

  const fetchModuleList = async (pageNo = 1) => {
    try {
      setLoading(true);
      const response = await apiClient.get(
        `${UNO_URL}${FETCH_MODULE_LIST}?page=${pageNo}&limit=${LIMIT}&search=${search}`
      );
      if (pageNo == 1) {
        setList(response);
      } else {
        setList((prev) => [...prev, ...response]);
      }
      setHasMore(response.length == LIMIT);
    } catch (error) {
      console.error("Fetch Module List Error:", error.message);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  const loadMoreModules = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchModuleList(nextPage);
  };

  const createModule = async (item) => {
    try {
      const payload = { name: item.name };
      await apiClient.post(`${UNO_URL}${CREATE_MODULE}`, payload);
      fetchModuleList(1);
    } catch (error) {
      console.log(error.message);
    } finally {
      setAddProject(false);
    }
  };

  const searchModuleForName = () => {
    setPage(1);
    fetchModuleList(1);
  };

  useEffect(() => {
    debounceFunc(searchModuleForName, 1000);
  }, [search]);

  return (
    <>
      <div className="projectPage">
        <div className="page-title">
          <div className="col-md-6">
            <h6>Module List</h6>
          </div>
          <div className="search-parent">
            <SearchBar placeholder="Search ..." value={search} onChange={(e) => setSearch(e.target.value)} />
            <NormalGradientButton
              icon={<AddProjectLightIcon />}
              text="Add Module"
              onClick={() => setAddProject(true)}
            />
          </div>
        </div>

        <div
          className="project-list-container"
          id="scrollableDivGroups"
          style={{
            height: "calc(100vh - 200px)",
            overflowY: "auto",
            overflowX: "hidden",
            padding: "10px 0",
            scrollbarWidth: "thin",
            scrollbarColor: "#ccc transparent",
          }}
        >
          {loading && list.length === 0 ? (
            <div className="card-list">
              <ProjectSkeleton count={5} />
            </div>
          ) : list.length === 0 ? (
            <div className="empty-state">
              <NoDataImage />
              <p>
                {search.length > 0
                  ? `No modules found for "${search}".`
                  : "You haven’t created or joined any modules yet."}
              </p>
              {!isMobileView && (
                <p>
                  Click <strong>"Add Module"</strong> above to get started.
                </p>
              )}
            </div>
          ) : (
            <div id="scrollableDivGroups" className="scrollable-container">
              <InfiniteScroll
                dataLength={list.length}
                next={loadMoreModules}
                hasMore={hasMore}
                loader={
                  <div className="card-list">
                    <ProjectSkeleton count={5} />
                  </div>
                }
                scrollThreshold={0.4}
                scrollableTarget="scrollableDivGroups"
              >
                <div className="card-list">
                  {list.map((project) => (
                    <div
                      className="card-item"
                      key={project.uuid}
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/modules/creation/${project.uuid}`)}
                    >
                      <div className={project?.versions?.[0]?.data?.thumbnail ? "card-thumb" : "card-thumb not-thumb"}>
                        <img
                          src={project?.versions?.[0]?.data?.thumbnail || DefaultImage}
                          alt={project.name}
                          referrerPolicy="no-referrer"
                        />
                      </div>

                      <div className="card-info">
                        <div className="card-info-item">
                          <h6 title={project.name}>{project.name}</h6>
                        </div>

                        {project.owner && (
                          <div className="owner-detail">
                            {project?.owner?.avatar ? (
                              <img src={project?.owner?.avatar} referrerPolicy="no-referrer" alt="User Profile" />
                            ) : (
                              <span className="initials">
                                {project?.owner?.name
                                  ?.split(" ")
                                  ?.slice(0, 2)
                                  ?.map((word) => word[0])
                                  ?.join("")
                                  ?.toUpperCase()}
                              </span>
                            )}
                            <p className="user-name">{project?.owner?.name}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
            </div>
          )}
        </div>
      </div>

      <AddProject show={addProject} handleClose={() => setAddProject(false)} onAdd={createModule} />
    </>
  );
};

export default ModuleList;
